if (!customElements.get('hollow-product-sticky')) {
  customElements.define('hollow-product-sticky', class extends HTMLElement {
    connectedCallback() {
      this.productInfo = this.closest('product-info');
      if (!this.productInfo) return;
      this.button = this.querySelector('button');
      this.cta = document.getElementById(this.dataset.productForm)?.querySelector('[name="add"]');
      this.footer = document.querySelector('footer');
      this.pastBuyBox = false;
      this.footerVisible = false;
      this.sync = () => {
        const offer = this.productInfo.querySelector('hollow-product-offers [data-quantity][aria-checked="true"]');
        const price = this.productInfo.querySelector('[data-hollow-atc-price]');
        const nativePrice = this.productInfo.querySelector('.hollow-legacy-price > span:first-child');
        const priceText = offer?.dataset.total || nativePrice?.textContent || [...(price?.childNodes || [])].filter(node => node.nodeType === Node.TEXT_NODE).at(-1)?.textContent?.replace(/^\s*[·–-]\s*/, '').trim();
        if (priceText) this.querySelector('[data-hollow-sticky-price]').textContent = priceText;
        const compare = this.querySelector('[data-hollow-sticky-compare]');
        if (compare) {
          const compareText = offer ? (Number(offer.dataset.quantity) > 1 ? offer.dataset.compare : '') : this.productInfo.querySelector('.hollow-legacy-price > s')?.textContent;
          compare.textContent = compareText || '';
          compare.hidden = !compareText;
        }
      };
      this.scheduleSync = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(this.sync);
      };
      this.onClick = () => this.productInfo.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      this.button.addEventListener('click', this.onClick);
      this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (data.sectionId !== this.dataset.section) return;
        const options = (data.variant?.options || []).filter(value => value && value !== 'Default Title');
        const text = options.length ? `(${options.join(', ')})` : '';
        this.querySelectorAll('[data-hollow-sticky-variants]').forEach(label => { label.textContent = text; });
        this.scheduleSync();
      });
      this.updateVisibility = () => {
        const visible = this.pastBuyBox && !this.footerVisible;
        this.classList.toggle('is-visible', visible);
        this.setAttribute('aria-hidden', String(!visible));
        this.inert = !visible;
      };
      this.measureVisibility = () => {
        this.visibilityFrame = null;
        if (!this.isConnected || !this.cta) return;
        this.pastBuyBox = this.cta.getBoundingClientRect().bottom < 0;
        this.footerVisible = Boolean(this.footer && this.footer.getBoundingClientRect().top <= window.innerHeight);
        this.updateVisibility();
      };
      this.scheduleVisibility = () => {
        if (this.visibilityFrame == null) this.visibilityFrame = requestAnimationFrame(this.measureVisibility);
      };
      window.addEventListener('scroll', this.scheduleVisibility, { passive: true });
      window.addEventListener('resize', this.scheduleVisibility, { passive: true });
      window.addEventListener('pageshow', this.scheduleVisibility);
      if (this.cta && 'IntersectionObserver' in window) {
        this.visibilityObserver = new IntersectionObserver(entries => {
          for (const entry of entries) {
            if (entry.target === this.cta) this.pastBuyBox = entry.boundingClientRect.bottom < 0;
            if (entry.target === this.footer) this.footerVisible = entry.isIntersecting || entry.boundingClientRect.top <= window.innerHeight;
          }
          this.updateVisibility();
        }, { threshold: 0 });
        this.visibilityObserver.observe(this.cta);
        if (this.footer) this.visibilityObserver.observe(this.footer);
      }
      const price = this.productInfo.querySelector('[data-hollow-atc-price]');
      if (price) {
        this.priceObserver = new MutationObserver(this.scheduleSync);
        this.priceObserver.observe(price, { subtree: true, childList: true, characterData: true });
      }
      this.sync();
      this.scheduleVisibility();
    }
    disconnectedCallback() {
      this.button?.removeEventListener('click', this.onClick);
      this.unsubscribeVariant?.();
      this.visibilityObserver?.disconnect();
      this.priceObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.visibilityFrame);
      this.visibilityFrame = null;
      window.removeEventListener('scroll', this.scheduleVisibility);
      window.removeEventListener('resize', this.scheduleVisibility);
      window.removeEventListener('pageshow', this.scheduleVisibility);
    }
  });
}
